import { ReactHTMLElement, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import Table from "../../../core/common/dataTable/index";
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod';
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl';
import Loading from '../../../core/common/custom-loading/Loading';

// const chooseStatus = [
//     { value: "", label: "Select" },
//     { value: "active", label: "Active" },
//     { value: "resume", label: "Resume" },
//     { value: "suspended", label: "Suspend" },
// ]


const NfOrganisations = () => {
    const [loading, setLoading] = useState(false)
    const [allItemList, setAllItemList] = useState<any[]>([])
    console.log("state me data", allItemList)
    const routes = all_routes;


    const columns = [
        {
            title: "Sr No.",
            dataIndex: "SrNo",
            render: (text: string, record: any, index: number) => (
                <h6 className="fw-medium fs-14 text-dark" style={{ width: "40px" }}>{index + 1}</h6>
            ),
            // sorter: (a: any, b: any) => a.SrNo - b.SrNo,
            sorter: false,
        },
        {
            title: "Action",
            dataIndex: "actions",
            render: (value: string, record: any, index: number) => {
                const status = record?.status?.toLowerCase();
                // console.log(status)
                return (
                    <select
                        defaultValue={status}
                        onChange={(e) => {
                            setAllItemList((prev) => (
                                prev.map(i => (i.organization_id === record?.organization_id) ? { ...i, status: e.target.value } : i)
                            ))
                        }}
                        // onChange={(e) => handleChangeStatus(e.target.value, index)}
                        className="form-select"
                        style={{
                            width: "100px",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            backgroundColor: "#fff",
                        }}
                    >
                        <option value="suspended">Suspend</option>
                        <option value="resume" hidden={record?.status !== "suspended"}>Resume</option>
                        <option value="active">Active</option>
                    </select>
                )
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string, record: any,) => (
                <p className="text-capitalize">{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.status || "").localeCompare(b.status || ""),
        },
        {
            title: "View Properties",
            dataIndex: "",
            render: (text: string, record: any,) => {
                const org_id = btoa(record?.organization_id);
                return (
                    <Link to={`/properties`} className="btn-link text-info text-decoration-none ps-5" onClick={() => localStorage.setItem("org-id", org_id)}>View</Link>
                )
            },
            // sorter: (a: any, b: any) => (a.organization_name || "").localeCompare(b.organization_name || ""),
        },
        {
            title: "View Staff",
            dataIndex: "",
            render: (text: string, record: any,) => {
                const org_id = btoa(record?.organization_id);
                return (
                    <Link to={`${routes.GetStaffDetails}`} className="btn-link text-info btn-link text-info text-decoration-none ps-3" onClick={() => localStorage.setItem("org-id", org_id)}>View</Link>
                )
            },
            // sorter: (a: any, b: any) => (a.organization_name || "").localeCompare(b.organization_name || ""),
        },
        {
            title: "Organization Name",
            dataIndex: "organization_name",
            render: (text: string, record: any,) => (
                <p className="fs-14 text-capitalize">{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.organization_name || "").localeCompare(b.organization_name || ""),
        },
        {
            title: "Organization Type",
            dataIndex: "organization_type",
            render: (text: string, record: any) => {
                return <p>{text ?? "-"}</p>
            },
            sorter: (a: any, b: any) => (a.organization_type || "").localeCompare(b.organization_type || ""),
        },
        {
            title: "Email",
            dataIndex: "contact_email",
            render: (text: string, record: any) => {
                return <p className='flex-wrap' style={{ width: "130px" }}>{text ?? "-"}</p>
            },
            sorter: (a: any, b: any) => (a.contact_email || "").localeCompare(b.contact_email || ""),
        },
        {
            title: "Contact No.",
            dataIndex: "contact_phone",
            render: (text: string, record: any) => {
                return <p>{text ?? "-"}</p>
            },
            sorter: (a: any, b: any) => a.contact_phone - b.contact_phone,
        },
        {
            title: "Address",
            dataIndex: "address",
            render: (text: string, record: any,) => (
                <p className="">{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.address || "").localeCompare(b.address || ""),
        },
        {
            title: "Pincode",
            dataIndex: "pincode",
            sorter: (a: any, b: any) => a.pincode - b.pincode,
        },
        {
            title: "City/State",
            dataIndex: "city_state",
            render: (text: string, record: any,) => (
                <p className="">{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.city_state || "").localeCompare(b.city_state || ""),
        },
        {
            title: "Pan Number",
            dataIndex: "pan_number",
            render: (text: string, record: any,) => (
                <p className="">{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.pan_number || "").localeCompare(b.pan_number || ""),
        },
    ];

    const fetchData = async () => {
        try {
            setLoading(true)
            const resp = await AXIOSCONFIGMETHOD("post", webServiceUrl.FETCH_ALL_ORGANISATION);
            console.log(resp, "bhawna")
            if (resp?.success) {
                const final = resp?.data;
                console.log("ncncncncc", final)
                setAllItemList(final?.length > 0 && final);
            }
        } catch (error) {
            console.error("Error fetching  data:", error);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    }

    useEffect(() => {
        localStorage.removeItem("org-id");
        fetchData()
    }, [])

    // console.log(allItemList);

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Organizations</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Dashboard
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        All Organization
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* Performance Indicator list */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Organization List</h5>
                        </div>
                        <div className="card-body p-0">
                            {loading
                                ? <Loading />
                                : <Table dataSource={allItemList} rowKeyId={"organization_id"} columns={columns} Selection={false} />
                            }
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
               <p className="mb-0">© {new Date().getFullYear()} Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    )
}

export default NfOrganisations
